import apiClient from 'clients/apiClient';
import config from 'helpers/config';

/**
 * Executes an HTTP request to duplicate a product.
 *
 * @param {number} id
 * @returns {Promise}
 */
export const duplicateProductRequest = (id) => {
    const url = `${ config.getApiBaseUrl() }/products/${ id }/duplicate`;

    return apiClient.create(url);
};



// WEBPACK FOOTER //
// ./src/http/requests/products/productsRequests.js